import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {UserCarePlanDgSearchResults} from "../models/datagrid-search-results/user-care-plan.dg-search-results.model";
import {UserCarePlanService} from "../providers/user-care-plan.service";

@Injectable()
export class UserCarePlanResolve implements Resolve<UserCarePlanDgSearchResults> {
  constructor(private userCarePlanService: UserCarePlanService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<UserCarePlanDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.userCarePlanService.getResults(environment.DEFAULT_RESULTS_LIMIT, 0, 'ASC', 'created').pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
